import React from 'react';
import { SectionHeader } from '../util/Components';
import AnnouncementView from './announcements/AnnouncementView';
import Settings from './Settings';

export default function(props) {
  const { ministry, updateMinistry, ...otherProps } = props;

  return (
    <center>
      <SectionHeader title="Announcements" />
      <AnnouncementView ministry={ministry} {...otherProps} />
      <SectionHeader title="Settings" />
      <Settings updateMinistry={updateMinistry} ministry={ministry} {...otherProps} />
    </center>
  );
}



/** WEBPACK FOOTER **
 ** ./src/ministry/Combined.js
 **/